export enum TriggerTypes {
  positiveEdge='POS',
  negativeEdge='NEG',
  highWaterMark='HIGH',
  lowWaterMark='LOW',
  range='RANGE'
}
